import React, { useState } from "react";
import axios from "axios";
import EditKeywordModal from "./EditKeywordModal";

/**
 * @param {Object} props
 * @param {Object} props.poster 선택된 포스터 객체
 * @param {Function} props.onClose 모달 닫기 콜백
 * @param {Function} props.onUpdatePoster 키워드 수정 후 PosterListPage의 상태를 갱신하기 위한 콜백
 */
export default function PosterModal({ poster, onClose, onUpdatePoster }) {
    const [showEditModal, setShowEditModal] = useState(false);

    // 키워드 수정 모달 열기
    const handleEdit = () => {
        setShowEditModal(true);
    };

    const handleDelete = async () => {

        const ok = window.confirm("정말 삭제하시겠습니까?");
        if (!ok) return;


        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/poster/delete/${poster.id}`,
            );

            if ( response.status === 200 ) {
                alert("삭제되었습니다 새로고침 해주세요")
            } else {
                alert("다시 시도해주세요")
            }

        } catch (e) {
            alert("삭제하는데 실패했습니다")
        }
    };


    // 다운로드
    const handleDownload = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/poster/download/${poster.id}`,
                {
                    responseType: "blob",
                }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", poster.name + ".png"); // 파일명
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.error("다운로드 실패:", e);
            alert("파일 다운로드에 실패했습니다.");
        }
    };

    return (
        <div
            className="fixed overflow-auto inset-0 bg-opacity-40 z-50 flex justify-center items-start pt-[10vh]"
            onClick={onClose} // 배경 클릭 시 닫기
        >
            {/* 모달 내용 영역 클릭해도 닫히지 않도록 버블링 막기 */}
            <div
                className="bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-4xl"
                onClick={(e) => e.stopPropagation()}
            >
                {/* 포스터 이름 */}
                <h3 className="text-xl font-bold mb-4">{poster.name}</h3>
                {/* 키워드 목록 */}
                <div className="flex flex-wrap gap-2">
                    {poster.keywords?.map((k, i) => (
                        <span
                            key={i}
                            className="bg-gray-200 px-3 py-1 rounded-full text-sm"
                        >
              {k}
            </span>
                    ))}
                </div>

                <br/>

                {/* 포스터 이미지 (preview API 예시) */}
                <img
                    src={`${process.env.REACT_APP_API_REAL_URL}/${poster.filePath}`}
                    alt="preview"
                    className="w-full h-full rounded mb-4"
                />

                {/* 버튼 영역 */}
                <div className="mt-6 flex justify-end gap-2">
                    <button
                        onClick={handleDownload}
                        className="bg-green-600 text-white px-4 py-2 rounded shadow"
                    >
                        다운로드
                    </button>

                    <button
                        onClick={handleEdit}
                        className="bg-red-600 text-white px-4 py-2 rounded shadow"
                    >
                        수정
                    </button>

                    <button
                        onClick={handleDelete}
                        className="bg-blue-600 text-white px-4 py-2 rounded shadow"
                    >
                        삭제
                    </button>

                    <button
                        className="px-4 py-2 bg-gray-300 rounded"
                        onClick={onClose}
                    >
                        닫기
                    </button>
                </div>

                {/* 키워드 수정 모달 */}
                {showEditModal && (
                    <EditKeywordModal
                        initialKeywords={poster.keywords || []}
                        posterId={poster.id}
                        onClose={() => setShowEditModal(false)}
                        onUpdatePoster={(updated) => {
                            onUpdatePoster(updated);
                            setShowEditModal(false);
                        }}
                    />
                )}
            </div>
        </div>
    );
}